import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BaseComponentService } from '../../../services/base-component.service';
import { BancoArrecadador } from '../../../models/pagamento/banco-arrecadador';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

@Component({
  selector: 'gpa-detalhe-liquidacao',
  templateUrl: './detalhe-liquidacao.component.html'
})
export class DetalheLiquidacaoComponent extends BaseComponentService implements OnInit {

  @Input() liquidacao: any; 

  formDetalhe: FormGroup;

  /*
  *  Máscaras dos controles do formulário
  */
  pedEmpLiqMask = '00000.0000.00.0000000-0';
  codigoCredorMask = '0000.00000-00';
  cpfMask = '000.000.000-00';
  cnpjMask = '00.000.000/0000-00';

  nomeBanco = "";

  ngOnInit() {
    this.criarFormulario();
    
    if(this.liquidacao.codBancoCredor!=null){
    this.getBanco(this.liquidacao.codBancoCredor).subscribe(bancoArrecadador => {
      const nomeBanco = ("000" + bancoArrecadador.id).slice(-3) +" - "+ bancoArrecadador.nome
      this.atualizarControle('codBancoCredor', nomeBanco != null ? nomeBanco :'-');
    }); 
    } 
    
    this.getNomeFormaRecebimento(this.liquidacao.codigoFormaRecebimento).subscribe(nome => {
      this.atualizarControle('formaRecebimento', nome != null ? nome : '-');
    });

    this.atualizarFormulario();
  }

  criarFormulario() {
    this.formDetalhe = this.fb.group({
      dataLiq: this.fb.control({value: '', disabled: true}),
      numeroLiq: this.fb.control({value: '', disabled: true}),
      valorLiq: this.fb.control({value: '', disabled: true}),
      numeroPed: this.fb.control({value: '', disabled: true}),
      numeroEmp: this.fb.control({value: '', disabled: true}),
      numeroProcessoSei: this.fb.control({value: '', disabled: true}),
      historico: this.fb.control({value: '', disabled: true}),
      codigoCredor: this.fb.control({value: '', disabled: true}),
      nomeCredor: this.fb.control({value: '', disabled: true}),
      cpfCnpjCredor: this.fb.control({value: '', disabled: true}),
      codBancoCredor: this.fb.control({value: '', disabled: true}),
      codAgenciaCredor: this.fb.control({value: '', disabled: true}),
      contaCredor: this.fb.control({value: '', disabled: true}),
      tipoContaCredor: this.fb.control({value: '', disabled: true}),
      formaRecebimento :this.fb.control({value: '-', disabled: true})
    });
  }

  atualizarFormulario() {
    this.atualizarControle('dataLiq', this.liquidacao.dataEnvioLiq);
    this.atualizarControle('numeroLiq', this.liquidacao.numeroLiq);
    this.atualizarControle('valorLiq', this.liquidacao.valorLiq);
    this.atualizarControle('numeroPed', this.liquidacao.numeroPed);
    this.atualizarControle('numeroEmp', this.liquidacao.numeroEmp);
    this.atualizarControle('numeroProcessoSei', this.liquidacao.numeroProcessoSei);
    this.atualizarControle('historico', this.liquidacao.historico);
    this.atualizarControle('codigoCredor', this.liquidacao.codigoCredor);
    this.atualizarControle('nomeCredor', this.liquidacao.nomeCredor);
    this.atualizarControle('cpfCnpjCredor', this.liquidacao.cpfCnpjCredor);
    this.atualizarControle('codAgenciaCredor',  this.liquidacao.codAgenciaCredor!=null?this.liquidacao.codAgenciaCredor:"-");
    this.atualizarControle('contaCredor', this.liquidacao.numContaBancariaCredor!=null?this.liquidacao.numContaBancariaCredor +'/'+ this.liquidacao.digContaBancariaCredor:"-");
    this.atualizarControle('tipoContaCredor', this.liquidacao.tipoContaCredor!=null?(this.liquidacao.tipoContaCredor==1?"Conta Corrente":"Poupança"):"-");

   }

 /*
  * Atualiza o conteúdo do controle verificando a nulidade do futuro conteúdo.
  */
  atualizarControle(controle: string, value: any) {
    this.formDetalhe.get(controle).setValue(value === null || value === undefined ? '-' : value.toString());
  }

 /*
  * Retorna a máscara de CPF ou CNPJ do credor de acordo com o tamanho da string.
  */
  getCpfCnpjMask(controle: string) {
    const valor = this.formDetalhe.get(controle).value;

    if (valor.length === 11) {
      return this.cpfMask;
    } else if (valor.length === 14) {
      return this.cnpjMask;
    }
    else {
      return '';
    }
  }

   /*
  * Retorna a máscara de CPF ou CNPJ do credor de acordo com o tamanho da string.
  */
   getProcessoSeiMask() {
    if (this.formDetalhe.get('numeroProcessoSei').value.length === 20) {
      return '000.0000.0000.0000000-00'; 
    } else{
      return '0000.0000.0000.0000000-00';;
    }
  }
  getCodConsignataMask(){
    if (this.formDetalhe.get('codigoCredorConsignataria').value.length < 2){
      return '';
    }
    else{
      return this.codigoCredorMask;
    }
  }

  /*
   * Carregar informacao de Banco da API.
   */
  getBanco(idBanco: number): Observable<BancoArrecadador>{
    this._service.routePrefix = `/api/BancoArrecadador/${idBanco}`;

    return this._service.getById(null, 'gpa').pipe(
      map((bancoArrecadador: BancoArrecadador) => bancoArrecadador)
    );    
  }

  getNomeFormaRecebimento(codForma: number): Observable<string> {
    this._service.routePrefix = `/api/FormaRecebimento/Obter/${codForma}`;
  
    return this._service.getById(null, 'gpa').pipe(
      map((formaRecebimento: any) => formaRecebimento.nome)
    );
  }


}



// WEBPACK FOOTER //
// ./src/app/pagamento/relatorios/detalhe-liquidacao/detalhe-liquidacao.component.ts